

export enum NoteType {
    DOCUMENT    = 'document',
    WHITEBOARD  = 'whiteboard'
}
